// extracted by mini-css-extract-plugin
export var errorsContainer = "_tm-1";
export var link = "_tm-0";